import { render, staticRenderFns } from "./NewsTableViewForm.vue?vue&type=template&id=cc185804&"
import script from "./NewsTableViewForm.vue?vue&type=script&lang=js&"
export * from "./NewsTableViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports